<template>
  <v-main class="chayan">
    <v-container class="pa-0">
      <v-card :loading="loading" max-width="600" class="mx-auto">
        <v-img src="@/assets/cooking.png"></v-img>
        <div class="imgtxt">承诺达标合格证</div>
        <v-card-title class="pb-0">产品名称：{{mainData.ProductName}}</v-card-title>
        <div v-if="mainData.ShowHgzStatus" class="passbox">
          <v-img v-if="mainData.HgzStatus" class="passimg" src="@/assets/pass.png"></v-img>
          <v-img v-else class="passimg" src="@/assets/nopass.png"></v-img>
        </div>
        <v-card-text class="pt-1">
          <v-row align="center" class="mx-0">
            <v-rating :value="getRating" color="amber" dense half-increments readonly size="14"></v-rating>
            <div class="ml-4 grey--text">{{getRating}} (参与数:{{mainData.RatingNums}})
              <v-btn small text color="warning lighten-2" class="ml-4" @click="dialog=true">产品打分</v-btn>
              <v-dialog v-model="dialog" max-width="290">
                <v-card class="mx-auto elevation-16" width="300">
                  <v-card-title class="headline">产品评分</v-card-title>
                  <v-card-text>
                    <div class="text-center">
                      <v-rating v-model="rating" color="warning lighten-2" half-increments hover></v-rating>
                    </div>
                    <v-col cols="12">
                      <v-textarea rows="2" counter="255" label="评价" v-model.trim="rattext"></v-textarea>
                    </v-col>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-space-between">
                    <v-btn text @click="dialog=false">取消</v-btn>
                    <v-btn color="primary" text @click="setRating">提交</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-row>
          <div>{{mainData.PiCiReMark}}</div>
          <div class="my-4 subtitle-1 lrlist">
            <div v-if="mainData.ShowChaMaNums">
            <span>查码次数:</span>
            <span v-if="mainData.EwmChaxunNums < 10" class="caption success--text">{{mainData.EwmChaxunNums}}</span>
            <span v-else class="caption warning--text">注意:该码被查询超过{{mainData.EwmChaxunNums}}次</span>
            </div>
            <div><span>批次编号:</span><span>{{mainData.PiCi}}</span></div>
            <div><span>产品规格:</span><span>{{mainData.HgzProductNums}}{{mainData.HgzProductUnit}}</span></div>
            <div><span>开具日期:</span><span>{{mainData.HgzDateAt}}</span></div>
          </div>
        </v-card-text>
        <div>
          <v-divider class="mx-4"></v-divider>
          <v-card-title>生产者信息</v-card-title>
          <v-card-text class="subtitle-1 lrlist text--secondary">
            <div><span>生产者:</span><span>{{mainData.UserName}}</span></div>
            <div v-if="mainData.UserFaren && mainData.UserType == 1">
              <span>企业法人:</span><span>{{mainData.UserFaren}}</span></div>
            <div><span>联系电话:</span><span>{{mainData.UserPhone}}</span></div>
            <div><span>生产地址:</span><span>{{mainData.UserAddr}}</span></div>
            <!-- <div v-if="mainData.UserYyzz"><span>生产者证照:</span><span></span>
            </div>
            <v-row>
              <v-col v-if="mainData.UserYyzz" cols="4">
                <v-img class="rounded-lg elevation-3" :src="$store.state.serverhosts + mainData.UserYyzz"
                  aspect-ratio="1" @click="viewImg(mainData.UserYyzz)"></v-img>
              </v-col>
            </v-row> -->
          </v-card-text>
        </div>
        <div>
          <v-divider class="mx-4"></v-divider>
          <v-card-title>生产者承诺</v-card-title>
          <v-card-text>
            <div><span>我承诺对生产销售的食用农产品:</span></div>
            <div class="text--secondary">
              <div><span>1、不使用禁用农药兽药、停用兽药和非法添加物</span></div>
              <div><span>2、常规农药兽药残留不超标</span></div>
              <div><span>3、对承诺的真实性负责</span></div>
            </div>
          </v-card-text>
        </div>
        <div v-if="mainData.JiLu && mainData.JiLu.length > 0">
          <v-divider class="mx-4"></v-divider>
          <v-card-title>农事记录</v-card-title>
          <v-card-text>
            <v-chip-group v-model="selection" active-class="deep-purple accent-4 white--text" column>
              <v-chip v-for="(item,i) in mainData.JiLu" :key="i">{{item.DateAt}}</v-chip>
            </v-chip-group>
            <div v-if="selection >= 0">
              <div class="mt-3 subtitle-1">{{mainData.JiLu[selection].Title}}</div>
              <div class="my-3 text--secondary" style="text-indent:2em">{{mainData.JiLu[selection].Content}}</div>
              <v-row>
                <v-col cols="4" v-for="(item,i) in JSON.parse(mainData.JiLu[selection].ImgUrls)" :key="i">
                  <v-img class="rounded-lg elevation-3" :src="$store.state.serverhosts + item.url" aspect-ratio="1"
                    @click="viewImg(item.url)"></v-img>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </div>
        <v-card-text v-if="$store.state.gzhichi" align="center" class="mt-5 secondary grey--text lighten-2">
          技术支持:{{$store.state.gzhichi}}
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
  export default {
    data: () => ({
      loading: false,
      mainData: [],
      selection: 0,
      dialog: false,
      rating: 3.5,
      rattext: '',
    }),
    created() {
      this.init()
    },
    computed: {
      getRating() {
        if (this.mainData.RatingNums == 0) {
          return 3.5
        }
        return Math.round(this.mainData.RatingSums / this.mainData.RatingNums * 100) / 100
      }
    },
    methods: {
      viewImg(src) {
        this.$store.commit("setviewimg", this.$store.state.serverhosts + src);
      },
      setRating() {
        if (this.mainData.EwmId == 0) {
          this.dialog = false
          this.$store.commit("setsnack", { message: '预览模式不能添加评价！', color: 'warning' })
          return
        }
        let data = {
          PiCier: { Id: this.mainData.PiCiId },
          EwmStr: this.$route.params.ewmstr,
          Rating: parseFloat(this.rating),
          Rattext: this.rattext
        }
        this.loading = true
        this.$api.addRating(data).then(res => {
          this.loading = false
          this.dialog = false
          this.mainData.RatingSums = this.mainData.RatingSums + data.Rating
          this.mainData.RatingNums = this.mainData.RatingNums + 1
          this.$store.commit("setsnack", { message: '添加评价成功', color: 'success' });
        }).catch(error => {
          this.loading = false
          this.dialog = false
          let message = (error && error.msg) || "添加评价失败！";
          if (message == '您已经评价过了,谢谢！') {
            this.$store.commit("setsnack", { message, color: 'success' });
            return
          }
          this.$store.commit("setsnack", { message });
          console.error(error);
        })
      },
      init() {
        this.loading = true
        let data = {
          ewm: this.$route.params.ewmstr
        }
        this.$route.params.type && (data.type = this.$route.params.type)
        this.$api.hgzChaYan(data).then(res => {
          this.loading = false
          this.mainData = res.data
        }).catch(error => {
          this.loading = false
          if (error && error.msg && error.msg == '<QuerySeter> no row found') {
            error.msg = "查询失败，没有相关的记录！"
          }
          let message = (error && error.msg) || "二维码查询失败！";
          this.$store.commit("setsnack", { message });
          console.error(error);
        })
      }
    }
  }
</script>
<style scoped>
  .chayan .imgtxt {
    position: absolute;
    top: 80px;
    font-size: 28px;
    text-shadow: 1px 1px 1px black;
    color: white;
    width: 100%;
    text-align: center;
  }

  .chayan .passbox {
    position: relative;
    width: 100%;
  }

  .chayan .passbox .passimg {
    width: 90px;
    position: absolute;
    top: -35px;
    right: 10px;
    transform: rotate(17deg);
  }

  .chayan .lrlist div {
    display: flex;
    justify-content: space-between;
    line-height: 34px;
  }

  .chayan .lrlist div span:first-child {
    min-width: 80px;
  }

  .chayan .lrlist div span:last-child {
    text-align: right;
  }
</style>